exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html{background:#ccc;font-family:sans-serif}body{display:grid;justify-items:center;height:100vh}#calculator{border:2px solid #222;border-radius:4px;max-width:500px}#result{font-size:42px;width:100%;height:70px;box-sizing:border-box;display:grid;padding:10px;justify-items:end;align-items:center;border-bottom:2px solid #222}#pad{grid-template-columns:repeat(4,minmax(60px,1fr));grid-gap:10px;padding:15px}#pad,.btn{display:grid}.btn{cursor:pointer;font-size:20px;padding:15px 10px;justify-items:center;align-items:center;color:#fafafa;border:1px solid #222;border-radius:4px;background:#777}#clear{background:#4682b4}#clear,#zero{grid-column:1/4}#equal{background:#2e8b57}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-186f3192","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Calculator.vue
// module id = 32
// module chunks = 0